import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Slide from '@mui/material/Slide';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { LoadingButton } from '@mui/lab';

const Modals = (props) => {
    // eslint-disable-next-line react/prop-types
    const { open, handleclose, textboxlabel, addclickhandler, loadingbtn, onCancel } = props;

    const modalCloseHandler = () => {
        handleclose(true);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={() => { onCancel() }}

                fullWidth
                maxWidth="xs"
                // onClose={() => {
                //     handleclose(false);
                // }}
                aria-labelledby="alertmodalCloseHandler-dialog-title"
                aria-describedby="alert-dialog-description"
                BackdropProps={{ style: { background: 'rgba(0, 0, 0, 0.5)' } }}
            >
                <div>
                    <DialogTitle>{textboxlabel}</DialogTitle>
                    <DialogContent>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField autoFocus margin="dense" variant="standard" fullWidth {...props} />
                                    {/* <TextField autoFocus margin="dense" variant="standard" fullWidth {...props} /> */}

                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Box>
                            {/* <Button onClick={modalCloseHandler} autoFocus variant="outlined" style={{ marginRight: 5 }}>
                                Cancel
                            </Button> */}
                            <LoadingButton onClick={() => addclickhandler()} variant="contained" loading={loadingbtn}>
                                Add
                            </LoadingButton>
                        </Box>
                    </DialogActions>
                </div>
            </Dialog>
        </>
    );
};

export default Modals;
